import { BlogPost } from "@/types/blog";
import { content } from "./content";
import frommHabenSeinHero from "@/assets/blog/fromm-haben-sein-hero.webp";

export const FrommHabenSeinPost: BlogPost = {
  title: "Haben ist eine Taktik. Sein ist eine Strategie. Lieben ist die Kunst.",
  metaTitle: "Erich Fromm: Haben, Sein & die Kunst des Liebens",
  subtitle: "Ein Essay über das, was bleibt, wenn der Besitz vergeht.",
  excerpt: "Erich Fromm zeigt: Liebe ist keine Emotion, sondern Praxis. Entdecke den Unterschied zwischen Haben und Sein – und warum das dein Business und Leben verändert.",
  date: "14.10.2025",
  slug: "fromm-haben-sein",
  imageUrl: frommHabenSeinHero,
  category: "Philosophie",
  tags: ["Philosophie", "Beziehungen", "Coaching", "Psychologie", "Erich Fromm", "Humanismus"],
  author: "Jörg Hörmann",
  authorTitle: "Finanz- & Executive Coach",
  metaDescription: "Erich Fromm zeigt: Liebe ist keine Emotion, sondern Praxis. Entdecke den Unterschied zwischen Haben und Sein – und warum das dein Business und Leben verändert.",
  content
};
